import * as React from "react";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import { IAPPaymentMethod } from "../../src/generated/lib-domain/iap";
import PaymentSystemChangeInfoPage from "../pages/PaymentSystemChangeInfo";
import { AppState } from "../store";
import { URL_PATHS } from "../../src/routes";
import { PAYMENT_PLANS } from "../generated/lib-domain/paymentPlan";
import { PaymentPlanEnum } from "../generated/UserAPIAgent";

const PaymentSystemChangeInfoContainer = (): JSX.Element => {
    const paymentStatus = useSelector(
        (state: AppState) => state.payment.status
    );
    const canApplyForChangeToCard =
        paymentStatus.primaryPaymentMethod === IAPPaymentMethod.IOS_IAP &&
        (paymentStatus.paidFinishDate === null) !==
            (paymentStatus.nextPaymentDate === null);
    if (!canApplyForChangeToCard) {
        return <Redirect to={URL_PATHS.myPage()} />;
    }
    const differenceBetweenIapAndCardPayment =
        PAYMENT_PLANS.find(
            (plan) => plan.id === PaymentPlanEnum.STANDARD_1M_IOS_IAP_12000
        ).amount -
        PAYMENT_PLANS.find(
            (plan) => plan.id === PaymentPlanEnum.STANDARD_1M_CARD_9800
        ).amount;
    return (
        <PaymentSystemChangeInfoPage
            differenceFromIAP={differenceBetweenIapAndCardPayment}
        />
    );
};

export default PaymentSystemChangeInfoContainer;
